var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7031 22.6104L26.8118 22.6104",
    stroke: "#222222",
    strokeWidth: 1.72981,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7031 27.7998L21.6224 27.7998",
    stroke: "#222222",
    strokeWidth: 1.72981,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51367 11.1935C9.51367 9.74035 9.51367 9.01377 9.79648 8.45873C10.0452 7.9705 10.4422 7.57356 10.9304 7.3248C11.4854 7.04199 12.212 7.04199 13.6652 7.04199H21.6325C22.2671 7.04199 22.5845 7.04199 22.8831 7.11368C23.1478 7.17725 23.4009 7.28208 23.6331 7.42435C23.8949 7.58481 24.1193 7.80919 24.5681 8.25795L30.7852 14.4751C31.234 14.9238 31.4583 15.1482 31.6188 15.4101C31.7611 15.6422 31.8659 15.8953 31.9295 16.1601C32.0012 16.4587 32.0012 16.776 32.0012 17.4106V32.2972C32.0012 33.7503 32.0012 34.4769 31.7184 35.032C31.4696 35.5202 31.0727 35.9171 30.5844 36.1659C30.0294 36.4487 29.3028 36.4487 27.8496 36.4487H13.6652C12.212 36.4487 11.4854 36.4487 10.9304 36.1659C10.4422 35.9171 10.0452 35.5202 9.79648 35.032C9.51367 34.4769 9.51367 33.7503 9.51367 32.2972V11.1935Z",
    stroke: "#222222",
    strokeWidth: 1.72981
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.623 7.04199V13.2693C21.623 14.7225 21.623 15.4491 21.9059 16.0041C22.1546 16.4923 22.5516 16.8893 23.0398 17.138C23.5948 17.4208 24.3214 17.4208 25.7746 17.4208H32.0019",
    stroke: "#222222",
    strokeWidth: 1.72981
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.b068ad6e9e107e4048027c4c7bfb9048.svg";
export { ForwardRef as ReactComponent };